import { Component, EventEmitter, Input, Output } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { faDroplet, faTemperatureEmpty } from "@fortawesome/free-solid-svg-icons";
export interface CardVariant {
  title: string;
  icon: any;
  classes?: string;
  value: string;
}
@Component({
  selector: "app-summary-cards-variant",
  templateUrl: "./summary-cards-variant.component.html",
  styleUrl: "./summary-cards-variant.component.scss",
})
export class SummaryCardsVariantComponent {

  @Input() card: CardVariant

}
